"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreDetails = void 0;
var react_1 = __importDefault(require("react"));
var BodyText_1 = require("../BodyText");
var Tooltip_1 = require("../Tooltip");
var Icon_1 = require("../Icon");
var Stack_1 = require("../Stack");
var classnames_1 = __importDefault(require("classnames"));
exports.MoreDetails = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var full = _a.full, short = _a.short, _c = _a.direction, direction = _c === void 0 ? 't' : _c, className = _a.className, labelClassName = _a.labelClassName, iconClassName = _a.iconClassName, tooltipProps = _a.tooltipProps, size = _a.size, props = __rest(_a, ["full", "short", "direction", "className", "labelClassName", "iconClassName", "tooltipProps", "size"]);
    var MoreDetailsIconClassNames = classnames_1.default('MoreDetailsIcon', iconClassName, (_b = {},
        _b["MoreDetailsIcon--" + size] = size,
        _b));
    var MoreDetailsClassNames = classnames_1.default('d-if', className);
    return (react_1.default.createElement(Stack_1.Stack, __assign({ alignItems: "center", className: MoreDetailsClassNames }, props, { ref: ref }),
        react_1.default.createElement(BodyText_1.BodyText, { size: size, className: labelClassName }, short),
        short !== full && (react_1.default.createElement(Tooltip_1.Tooltip, __assign({ text: full, className: "lh-1", portal: true, direction: direction }, tooltipProps),
            react_1.default.createElement("div", { className: MoreDetailsIconClassNames },
                react_1.default.createElement(Icon_1.Icon, { name: "more_horiz" }))))));
});
//# sourceMappingURL=MoreDetails.js.map